module.exports = {
  VectorShape: {
    PluginName: "Forma",
  },
};
